import React, { useState } from "react";
import firebase from "../firebase";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setError] = useState("");
  const [authUser, setAuthUser] = useState("");

  const validation = (e) => {
    e.preventDefault();
    if (!email || !password) {
      setError("All input fields are required! please provide valid inputs.");
    } else {
      loginUser();
    }
  };

  const loginUser = () => {
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then((user) => {
        console.log(user);
        console.log(user.user.email, "is login successfully");
        setAuthUser(user.user.email);
      })
      .catch((err) => {
        setError("");
        setError(err.message);
        setEmail("");
        setPassword("");
      });
  };

  return (
    <div className="login container card">
      <div className="alert alert-dark" role="alert">
        Login to your account!
      </div>
      <form className="container" onSubmit={validation}>
        <div className="form-group">
          <label htmlFor="exampleInputEmail1">Email address</label>
          <input
            type="email"
            className="form-control"
            id="exampleInputEmail1"
            aria-describedby="emailHelp"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <small id="emailHelp" className="form-text text-muted">
            We'll never share your email with anyone else.
          </small>
        </div>
        <div className="form-group">
          <label htmlFor="exampleInputPassword1">Password</label>
          <input
            type="password"
            className="form-control"
            id="exampleInputPassword1"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <button type="submit" className="btn btn-primary">
          Login
        </button>
        <Link to={{ pathname: "/register", state: authUser }}>
          <button type="btn" className="btn btn-primary register">
            signup
          </button>
        </Link>
      </form>
      {errors !== "" ? (
        <div className="alert alert-danger">
          <h6>{errors}</h6>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default Login;
